import { ModalTypes, useModalManager } from '@wwt/core/modals'

export const useChat = () => {
	const showModal = useModalManager.use.showModal()

	const handleSelect = () => {
		showModal(ModalTypes.ChatAssistant)
	}

	return {
		handleSelect
	}
}
